import React from "react";

import CloseIcon from "@mui/icons-material/Close";
import { DrawerProps, IconButton, Drawer as MuiDrawer, Stack, Typography } from "@mui/material";
import { MaterialTooltip } from "components/tooltips/MaterialTooltip";

interface Props extends DrawerProps {
  title: string;
  handleClose: () => void;
}

export const Drawer: React.FC<Props> = ({ children, title, handleClose, ...props }) => {
  return (
    <MuiDrawer
      onClose={handleClose}
      PaperProps={{ sx: { borderRadius: "0 20px 20px 0", width: 520, overflow: "hidden" } }}
      {...props}
    >
      <Stack
        sx={{
          height: 50,
          bgcolor: "#EDF1F9",
          p: "0 20px",
          flexShrink: 0
        }}
        direction="row"
        alignItems="center"
        justifyContent="space-between"
      >
        <MaterialTooltip title={title} isShow>
          <Typography noWrap sx={{ fontSize: "16px", fontWeight: 400 }}>
            {title}
          </Typography>
        </MaterialTooltip>
        <IconButton onClick={handleClose}>
          <CloseIcon />
        </IconButton>
      </Stack>
      {children}
    </MuiDrawer>
  );
};
